












import Modal from "../core/Modals/Modal";
import InterventionReassignEmployeEdit from "./InterventionReassignEmployeModalPartials/InterventionReassignEmployeEdit";

export default {
    name: "InterventionReassignEmployeModal",
    components: { InterventionReassignEmployeEdit, Modal },
    props: {
        interventions: Array,
        showModal: Boolean,
    },
    methods: {
        closeModal(): void {
            this.$emit("close-modal");
        },
    },
};
